import { Card, Image, Container, Heading, Text } from "@chakra-ui/react"

export const RegistrationCard = ({ icon, heading, text }) => {
	return (
		<Card mt="20px" display="flex" flexDirection="row" maxW="xl" p="20px">
			<Image src={icon} alt="Task Icon" w="65px" h="65px" />
			<Container>
				<Heading size="md" fontWeight="bold" pb="5px">
					{heading}
				</Heading>
				<Text>{text}</Text>
			</Container>
		</Card>
	)
}
